'use client';

import { AdminPage } from '../../types';

interface AdminNavProps {
  currentPage: AdminPage;
  onNavigate: (page: AdminPage) => void;
  isSuperAdmin: boolean;
}

export default function AdminNav({ currentPage, onNavigate, isSuperAdmin }: AdminNavProps) {
  const navItems: { page: AdminPage; label: string; superAdminOnly?: boolean }[] = [
    { page: 'dashboard', label: '대시보드' },
    { page: 'receipts', label: '전표 관리' },
    { page: 'clients', label: '업체 관리', superAdminOnly: true },
    { page: 'settings', label: '회사 설정' },
    { page: 'users', label: '계정 관리', superAdminOnly: true },
  ];

  return (
    <nav className="bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex space-x-8">
          {navItems.map((item) => {
            if (item.superAdminOnly && !isSuperAdmin) return null;

            const isActive = currentPage === item.page;
            return (
              <button
                key={item.page}
                onClick={() => onNavigate(item.page)}
                className={`px-3 py-4 text-sm font-medium ${
                  isActive
                    ? 'text-white border-b-2 border-white'
                    : 'text-gray-300 hover:text-white'
                }`}
              >
                {item.label}
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
